import {
  useSelector as useReduxSelector,
  useDispatch as useReduxDispath,
  TypedUseSelectorHook
} from 'react-redux'
import { RootState } from '../../state/ducks/types'

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector
export const useDispatch = useReduxDispath
